export default function pagetop() {

  /* 一定Scroll時にPageTopボタンの表示
  ----------------------------------------------------------------- */
  var pageTop = $('#js-pageTop');

  pageTop.hide();

  $(window).scroll(function () {
    // スクロールが500に達したらボタン表示
    if ($(this).scrollTop() > 500) {
      pageTop.fadeIn();
    } else {
      pageTop.fadeOut();
    }

    /* フッターでPageTopボタンを固定
    ----------------------------------------------------------------- */
    // ドキュメントの高さ
    var scrollHeight = $(document).height();
    // 現在地
    var scrollPosition = $(window).height() + $(window).scrollTop();
    // footerの高さ（＝止めたい位置）
    var footHeight = $('footer').innerHeight() - 50;

    if (scrollHeight - scrollPosition <= footHeight) {
      // ドキュメントの高さと現在地の差がfooterの高さ以下の場合
      $(pageTop).removeClass('is-fixed');
    } else {
      // それ以外の場合
      $(pageTop).addClass('is-fixed');
    }
  });

}